export default __webpack_public_path__ + "static/media/Coffee-logo-design-on-transparent-background-PNG.136d8969.png";